@if (step != 7) {
  <div
    [ngClass]="{'row':true, 'row_main':step != 2 && step != 4 && step != 0 && step != 5 && step != 3 && step != 1}">
    <!--Bienvenida-->
    @if(step == 0){
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn"
        style="margin-top: 50px;">
        <div class="row padding-resp">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <div class="titulo-onboarding">
              solicita factoring al instante y monitorea tu negocio en tiempo real
            </div>
            <div class="subtitulo-onboarding">
              <strong>Sincroniza tu empresa</strong> y cursa <span (click)="open_modal_info(6)">operaciones de
            factoring</span> mientras sigues el progreso de tu negocio.
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" id="swiper-container-top">
          <div class="swiper-container">
            <swiper-container id="swiper" #swiper speed="1000" css-mode="false" loop="true" navigation="false"
              pagination="true" scrollbar="false" virtual="false" autoplay="true" pagination-clickable="true">
              <swiper-slide>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper1.svg" />
                      </div>
                      <div>
                        Accede a tu dashboard<br>contable
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper2.svg" />
                      </div>
                      <div>
                        Indentifica a tus<br>principales clientes
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper3.svg" />
                      </div>
                      <div>
                        Consulta el DICOM de<br>tu empresa
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper4.svg" />
                      </div>
                      <div>
                        Revisa tus facturas<br>pagadas
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper5.svg" />
                      </div>
                      <div>
                        Gestiona tus<br>proveedores
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper-container>
          </div>
          <div class="swiper-responsive">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" id="swiper-container-top">
              <div class="swiper-container-resp">
                <swiper-container id="swiper" #swiper speed="1000" css-mode="false" loop="true" navigation="false"
                  pagination="true" scrollbar="false" virtual="false" autoplay="true" pagination-clickable="true">
                  <swiper-slide>
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper1.svg" />
                      </div>
                      <div>
                        Accede a tu dashboard<br>contable
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper2.svg" />
                      </div>
                      <div>
                        Indentifica a tus<br>principales clientes
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper3.svg" />
                      </div>
                      <div>
                        Consulta el DICOM de<br>tu empresa
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper4.svg" />
                      </div>
                      <div>
                        Revisa tus facturas<br>pagadas
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="swipper-content">
                      <div>
                        <img src="../../assets/iconografia/swiper5.svg" />
                      </div>
                      <div>
                        Gestiona tus<br>proveedores
                      </div>
                    </div>
                  </swiper-slide>
                </swiper-container>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top responsive">
          <div class="subtitulo-onboarding ">
            Descubre <span (click)="open_modal_info(1)">qué es la sincronización</span> y conoce sus <span
          (click)="open_modal_info(2)">requisitos.</span>
        </div>
        <div class="caja-botones">
          <button mat-stroked-button class="primary-button" (click)="open_modal_info(7)">Sincronizar mi empresa</button>
          <!-- <button mat-stroked-button class="secondary-button" (click)="step = 0">Omitir por ahora</button> -->
          <button mat-stroked-button class="secondary-button" (click)="omitir()">Omitir por ahora</button>
        </div>
      </div>
    </div>
  </div>
}
<!--Clave sii-->
@if(step == 1){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-pink step-2 ">
        <div class="stepper-container">
          <div class="stepper">
            <div class="circulo-stepper-active">1</div>
            <div class="linea-stepper"></div>
            <div class="circulo-stepper">2</div>
          </div>
          <div class="texto-stepper">
            <div class="titulo-floating-onboarding">ingresa la clave SII <br>de tu empresa</div>
            <div class="subtitulo-floating-onboarding">
              Al <span (click)="open_modal_info(3)">vincularnos con el SII</span>, podremos evaluar <br>tu empresa para
              ofrecerte opciones de <br>factoring personalizadas.
            </div>
            <div class="contenedor-imagen">
              <img src="../../assets/iconografia/candado-sii.svg">
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-white">
        @if(loading == false){
          <div class="stepper-container2">
            <mat-card class="card-sii">
              <mat-card-content>
                <div class="titulo-onboarding">clave SII de tu empresa</div>
                <div class="formfield" style="position: relative;">
                  <span [mdePopoverTriggerFor]="appMontoPendiente" mdePopoverTriggerOn="hover"
                    #popoverTrigger="mdePopoverTrigger" class="icon-shield"><span class="material-symbols-outlined">enhanced_encryption</span></span>
                  <form [formGroup]="valForm">
                    <mat-form-field>
                      <input matInput placeholder="Clave SII empresa" [type]="hide ? 'password' : 'text'"
                        (keyup)="validate_key($event)" formControlName="clave_sii">
                      @if (valForm.controls['clave_sii'].hasError('incorrect')) {
                        <mat-error>
                          Clave SII inválida.
                        </mat-error>
                      }
                      @if (valForm.controls['clave_sii'].hasError('required')) {
                        <mat-error>
                          Clave SII requerida.
                        </mat-error>
                      }
                      <mat-hint>Ingresa la clave asociada a tu RUT empresa</mat-hint>
                      <span matSuffix class="material-icons" style="margin-right: 15px;" (click)="hide = !hide">
                        @if(!hide){
                          <span><span class="material-symbols-outlined">visibility</span></span>
                          }@else{
                          <span><span class="material-symbols-outlined">visibility_off</span></span>
                        }
                      </span>
                    </mat-form-field>
                  </form>
                  <mde-popover #appMontoPendiente="mdePopover" [mdePopoverOverlapTrigger]="false"
                    [mdePopoverCloseOnClick]="false">
                    <mat-card class="popover-card">
                      <mat-label>Tus datos estan protegidos por nuestra politica de<br>privacidad</mat-label>
                      <div class="politica" (click)="navegar_a('https://simplilatam.com/politica-de-privacidad/')">
                        <span>Ver politica de privacidad</span><span class="material-symbols-outlined">chevron_right</span>
                      </div>
                    </mat-card>
                  </mde-popover>
                </div>
                <div class="subtitulo-container">
                  <div class="subtitulo-onboarding">
                    Descubre <span (click)="open_modal_info(4)">cómo evitar errores</span> al ingresar tu clave.
                  </div>
                </div>
                <div class="caja-botones">
                  @if(success_sii == false){
                    <button [disabled]="disable_btn" (click)="verificar_guardar_clave_sii(true)" mat-stroked-button
                      class="primary-button">
                      @if (loading_sii == false) {
                        <span>Continuar</span>
                      }
                      @if (loading_sii == true) {
                        <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
                      }
                    </button>
                    }@else{
                    <button mat-stroked-button class="primary-button" (click)="pasar_al_paso_2()">Continuar</button>
                  }
                  <button mat-stroked-button class="secondary-button" (click)="step = 0">Volver</button>
                </div>
              </mat-card-content>
            </mat-card>
            <div class="contact-componente">
              <contact-container [tittle]="'Si tienes preguntas, puedes contactar a un ejecutivo.'"></contact-container>
            </div>
          </div>
          }@else{
          <div class="stepper-container2">
            <mat-card class="card-sii no-card">
              <mat-card-content>
                <loading-interno></loading-interno>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    </div>
  </div>
}
<!--Facturador-->
@if(step == 2){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <div class="row">
      <div
        [ngClass]="{'col-blue':facturador_seleccionado != null, 'col-lg-6 col-md-6 col-sm-6 col-xs-12 step-3 col-pink':true}">
        <div class="stepper-container">
          <div class="stepper">
            <div class="circulo-stepper">1</div>
            <div class="linea-stepper"></div>
            <div class="circulo-stepper-active">2</div>
          </div>
          <div class="texto-stepper">
            <div class="titulo-floating-onboarding">
              @if(facturador_seleccionado == null){
                selecciona el sistema de <br>facturación que utilizas
                }@else if(facturador_seleccionado != 1 && facturador_seleccionado != null){
                sistemas externos
                }@else if(facturador_seleccionado == 1){
                ventajas de utilizar Mipyme <br>(SII)
              }
            </div>
            <div class="subtitulo-floating-onboarding">
              @if(facturador_seleccionado == null){
                Si emites o cedes facturas por el <span (click)="open_modal_info(5)">sistema de <br>facturación</span> del
                SII, debes seleccionar la <br>opción <strong>Mipyme</strong>.
                }@else if(facturador_seleccionado == 1){
                Con Mipyme podrás acceder a la opción de <br>ceder las facturas por esta plataforma, cada vez <br> que
                realices una <span (click)="open_modal_info(6)">operación de factoring</span>.
                }@else if(facturador_seleccionado != 1 && facturador_seleccionado != null){
                Al usar un sistema externo, podrás cursar<br>
                <span (click)="open_modal_info(6)">operación de factoring</span>, pero no contarás,<br>
                con la opción de ceder tus facturas por<br>
                esta plataforma.
              }
            </div>
            <div class="contenedor-imagen">
              @if(facturador_seleccionado == null){
                <img src="../../assets/iconografia/candado-sii.svg">
                }@else if(facturador_seleccionado == 1){
                <img src="../../assets/iconografia/facturador.svg">
                }@else if(facturador_seleccionado != null && facturador_seleccionado != 1){
                <img src="../../assets/iconografia/facturador_externo.svg">
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-white">
        @if(loading == false){
          <div class="stepper-container2">
            <mat-card class="card-sii">
              <mat-card-content>
                <div class="titulo-onboarding">sistema de facturación</div>
                <div class="formfield" style="position: relative;">
                  <form [formGroup]="valFormFacturador">
                    <mat-form-field>
                      <mat-select formControlName="facturador" (selectionChange)="selecionar_facturador($event)"
                        placeholder="Sistema o software de facturación">
                        @for (i of facturadores; track i) {
                          <mat-option [value]="i.id">{{i.name}}</mat-option>
                        }
                      </mat-select>
                      <mat-hint>Selecciona el sistema que usas para ceder</mat-hint>
                    </mat-form-field>
                    @if (facturador_seleccionado == 7) {
                      <mat-form-field>
                        <input matInput placeholder="Nombre facturador" formControlName="otro">
                        @if (valFormFacturador.controls['otro'].hasError('required')) {
                          <mat-error>
                            Este campo es requerido.
                          </mat-error>
                        }
                        <mat-hint>Indica el nombre del sistema que usas para ceder</mat-hint>
                      </mat-form-field>
                    }
                  </form>
                </div>
                <div class="subtitulo-container">
                  <div class="subtitulo-onboarding">
                    <span (click)="open_modal_info(5)">¿Qué es un sistema de facturación?</span>.
                  </div>
                </div>
                <div class="caja-botones">
                  @if(this.facturador_seleccionado == 7){
                    <button [disabled]="this.valFormFacturador.controls['otro'].value == ''" mat-stroked-button
                    class="primary-button" (click)="put_facturador()">Finalizar</button>
                    }@else{
                    <button [disabled]="this.valFormFacturador.controls['facturador'].value == ''" mat-stroked-button
                    class="primary-button" (click)="put_facturador()">Finalizar</button>
                  }
                  <button mat-stroked-button class="secondary-button" (click)="step = 1">Volver</button>
                </div>
              </mat-card-content>
            </mat-card>
            <div class="contact-componente">
              <contact-container [tittle]="'Si tienes preguntas, puedes contactar a un ejecutivo.'"></contact-container>
            </div>
          </div>
          }@else{
          <div class="stepper-container2">
            <mat-card class="card-sii no-card">
              <mat-card-content>
                <loading-interno></loading-interno>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    </div>
  </div>
}
<!--Reconoce facturador MiPyme-->
@if(step == 3){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step-4"
    style="position: relative;">
    <mat-card class="centerabsolute step-4">
      <mat-card-content>
        <div class="container-final">
          <div class="container-titulos">
            <div class="label-negro">¡Felicidades {{user_name}}!</div>
            <div class="imagen-final-resp">
              <img src="../../assets/iconografia/basurero.svg">
            </div>
            <div class="label-azul">Completaste la sincronización de tu empresa</div>
            <div class="label-container" style="text-align: center !important;">Si cuentas con facturas para ceder,
            simula una operación de factoring y solicita la liquidez.</div>
            <div class="caja-botones">
              <!-- <button mat-stroked-button class="primary-button" (click)="open_modal_info(12)">Ver simulación</button> -->
              <button mat-stroked-button class="primary-button" (click)="step = 6">Ver simulación</button>
              <button mat-stroked-button class="secondary-button" (click)="navigateToHome()">Ir al inicio</button>
            </div>
          </div>
          <div class="imagen-final">
            <img src="../../assets/iconografia/basurero.svg">
          </div>
        </div>
        <div class="contact-componente">
          <contact-container [tittle]="'Si tienes preguntas, puedes contactar a un ejecutivo.'"></contact-container>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-pink">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-white">
      </div>
    </div>
  </div>
}
<!--Finalizar MIRAI-E dice que si-->
@if(step == 4){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step-4"
    style="position: relative;">
    <mat-card class="centerabsolute step-4">
      <mat-card-content>
        <div class="container-final">
          <div class="container-titulos">
            <div class="label-negro">¡Felicidades {{user_name}}!</div>
            <div class="imagen-final-resp">
              <img src="../../assets/iconografia/basurero.svg">
            </div>
            <div class="label-azul">Ya puedes financiar tu empresa con nosotros</div>
            <div class="label-container">Revisa tu simulación automática de financiamiento y haz tu primera <br><span
            (click)="open_modal_info(6)">operación de factoring</span> en Simpli.</div>
            <div class="caja-botones">
              <!-- <button mat-stroked-button class="primary-button" (click)="open_modal_info(12)">Ver simulación</button> -->
              <button mat-stroked-button class="primary-button" (click)="step = 6">Ver simulación</button>
            </div>
          </div>
          <div class="imagen-final">
            <img src="../../assets/iconografia/basurero.svg">
          </div>
        </div>
        <div class="contact-componente">
          <contact-container [tittle]="'Si tienes preguntas, puedes contactar a un ejecutivo.'"></contact-container>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-pink">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-white">
      </div>
    </div>
  </div>
}
<!--Finalizar pero cliente mal evaluado-->
@if(step == 5){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step-5"
    style="position: relative;">
    <mat-card class="centerabsolute step-5">
      <mat-card-content>
        <div class="container-final">
          <div class="container-titulos">
            <div class="label-negro">Estamos buscando la mejor alternativa de<br>factoring para tu negocio</div>
            <div class="imagen-final-resp">
              <img src="../../assets/iconografia/Iconografia - Development.png">
            </div>
            <div class="label-container" style="text-align: left;">Necesitamos realizar un <strong style="font-weight: bold;">análisis personalizado de tu empresa</strong><br>para obtener una propuesta adecuada.</div>
            <div class="noti-custom">
              <div><span class="material-symbols-outlined">notifications_active</span></div>
              <div>Al finalizar esta etapa, te notificaremos el resultado a tu correo y télefono.</div>
            </div>
            <div class="caja-botones" style="display: none;">
              <button mat-stroked-button class="primary-button" (click)="navigateToHome()">Ir al inicio</button>
            </div>
          </div>
          <div class="imagen-final">
            <img src="../../assets/iconografia/Iconografia - Development.png">
          </div>
        </div>
        <div class="contact-componente">
          <contact-container [tittle]="'Si tienes preguntas, puedes contactar a un ejecutivo.'"></contact-container>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-pink">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-white">
      </div>
    </div>
  </div>
}
</div>
}

@if (loading_step) {
  <div>
    <mat-card class="centerabsolute" style="max-width: 700px;">
      <mat-card-content>
        <div class="container-final" style="flex-direction: column;">
          <div class="imagen-final">
            <img src="../../assets/iconografia/Iconografia - Agency.png" style="height: 200px !important;">
          </div>
          <div class="container-titulos" style="margin-top: 20px;margin-bottom: 10px;">
            <div class="label-container">Estamos procensando la información.<br>Esto no tomará mucho tiempo.</div>
          </div>
          <div class="spinner-circle">
            <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}

<!--simulacion automatica-->
@if(step == 6){
  <app-simulacion-automatica [step]="substep" [id_simulation]="id_simulation" [stepper_cuentas]="formstep"
  [clave_unica]="signstep" [documentacionStep]="documentacionStep" [revisionStep]="revisionStep" [simulacion]="simulacion" [esEmpresaEnUnDia]="esEmpresaEnUnDia"></app-simulacion-automatica>
}

@if(step === null){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="height: 100vh;">
    <!-- Página en blanco -->
  </div>
}




<div style="position: absolute;top:0;">


  <input placeholder="ir al paso" style="border-radius: 4px;
  border: solid 1px #f0f0f0;
  background: none;display: none;" (change)="ir_al_paso($event)">

</div>